




































import { Component, Prop, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { utils, writeFile } from 'xlsx';
import { get, range, isNil } from 'lodash';

import type { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import type { TEntity } from '@/plugins/podolib/services/entities/Entity';

enum Side {
  Left = 'left',
  Right = 'right',
}

type ExportExcelMatrixColumn = {
  label: string;
  cmp?(payload: { index: number; side: Side }): string | number | boolean;
  key?: string;
};

type ExportExcelMatrix = ExportExcelMatrixColumn[];

@Component
export default class PatientAcquisitionExportationExcel extends MixinDialog {
  @Prop({ required: false }) patient!: TEntity<TPatient>;
  @Prop({ required: false }) acquisition!: TAcquisition;

  internalPatient: TEntity<TPatient> | null | undefined = null;
  internalAcquisition: TEntity<TAcquisition> | null | undefined = null;

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Analysis ExporterCsvOpened', {
        patientId: this._patient._id,
        acquisitionId: this._acquisition._id,
      });
    } else {
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Analysis ExporterCsvClosed', {
        patientId: this._patient._id,
        acquisitionId: this._acquisition._id,
      });
    }
  }

  get doctor() {
    return this.$store.state.pdc.doctor.current;
  }

  get _patient() {
    return this.internalPatient || this.patient;
  }

  get _acquisition() {
    return this.internalAcquisition || this.acquisition;
  }

  /**
   * Download Excel file of the current analysis
   */
  downloadExcelFile() {
    /*const acquisition = {
      metadata: {
        analysisType: 'podosmart',
        includeRecommendation: true,
        accel_resolution_g: 8,
        data: {
          analysisMode: null,
          mode: 'standard',
          solesMac: {
            left: 'D2:A4:83:CE:66:62',
            right: 'F1:D5:A6:F5:D9:DA',
          },
          solesSize: '36',
          fwVersion: '2.7.3',
          step: 'getting_data',
          progress: 97,
        },
        doctorId: '5ea2aa332a95d0001c604960',
        stationId: '5db6fe0c1857680028e70527',
        conditions: {
          pains: [],
          shoes_type: null,
          walking_aids: [],
        },
        pathologies: [],
        customPathologies: [],
        observation: '',
        solesId: '5d9b342d3ddb270a9c9acc31',
        patientId: '5f85a57be25396001d846542',
        weight: 52,
        height: 160,
        gender: 2,
        bmi: {
          value: 20.3,
          category: 'Normal weight',
        },
        footSize: 36,
        patientAge: 19,
        createdAt: '2020-10-13T13:04:24.012Z',
        version: {
          env: 'dev',
          semver: '1.0.9',
          git: 'a060bc742fbdd3a60af0749613ae776c389702c6',
          lambda: '54',
        },
      },
      left: {
        step_count: 34,
        distance: 52.028792826048225,
        cadence_global: 56.61598831837723,
        aggregates: {
          swing_speed: {
            avg: 2.078,
            std: 0.161,
          },
          step_by_step_cadence: {
            avg: 59.677,
            std: 2.88,
          },
          stance_time: {
            avg: 0.598,
            std: 0.028,
          },
          gaitline_FFO: {
            avg: 2.13,
            std: 0.166,
          },
          gaitline_foot_in: {
            avg: 2.755,
            std: 0.483,
          },
          gaitline_foot_out: {
            avg: 2.903,
            std: 0.16,
          },
          gaitline_FFI: {
            avg: 2.203,
            std: 0.238,
          },
          swing_time: {
            avg: 0.395,
            std: 0.027,
          },
          pronation_angle_foot_in: {
            avg: -7.461,
            std: 1.944,
          },
          pronation_angle_FFI: {
            avg: -7.626,
            std: 0.664,
          },
          pronation_angle_FFO: {
            avg: -8.48,
            std: 0.557,
          },
          pronation_angle_foot_out: {
            avg: -3.852,
            std: 2.545,
          },
          propulsion_speed: {
            avg: 2.143,
            std: 0.244,
          },
          stride_length: {
            avg: 1.424,
            std: 0.102,
          },
          loading_time: {
            avg: 0.094,
            std: 0.009,
          },
          propulsion_time: {
            avg: 0.246,
            std: 0.017,
          },
          flatfoot_time: {
            avg: 0.259,
            std: 0.018,
          },
          walking_speed: {
            avg: 1.382,
            std: 0.213,
          },
          foot_progression_angle_FF: {
            avg: -0.481,
            std: 5.973,
          },
          clearance: {
            avg: 0.009,
            std: 0.008,
          },
          circumduction: {
            avg: 0.017,
            std: 0.026,
          },
          plantar_flexion_angle_foot_in: {
            avg: -27.904,
            std: 1.963,
          },
          plantar_flexion_angle_foot_out: {
            avg: 58.719,
            std: 7.509,
          },
        },
        steps: [
          {
            swing_speed: 1.8957998372970553,
            step_by_step_cadence: null,
            stance_time: null,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.9701697257267352,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3750000002514142,
            pronation_angle_foot_in: -5.146540971062955,
            pronation_angle_FFI: -8.181424530848085,
            pronation_angle_FFO: -9.246155122360566,
            pronation_angle_foot_out: 0.19759143075837904,
            propulsion_speed: 2.0312943016138325,
            stride_length: 1.312718328337469,
            loading_time: null,
            propulsion_time: null,
            flatfoot_time: null,
            walking_speed: null,
            foot_progression_angle_FF: 4.329568365052798,
            clearance: null,
            circumduction: -0.012403708836863219,
            plantar_flexion_angle_foot_in: -27.893583311737327,
            plantar_flexion_angle_foot_out: 64.6588525466916,
            step_by_step_angle: 3.207445257700891,
            cumulative_distance: 1.312718328337469,
            time_foot_in: 1.9711538,
          },
          {
            swing_speed: 2.413141234921957,
            step_by_step_cadence: 57.77777773904137,
            stance_time: 0.5769230773098681,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.4044088513199635,
            gaitline_FFI: 2.0,
            swing_time: 0.3942307694950764,
            pronation_angle_foot_in: -6.841450317974402,
            pronation_angle_FFI: -7.9351900841189495,
            pronation_angle_FFO: -8.921856276930596,
            pronation_angle_foot_out: -7.973911259835638,
            propulsion_speed: 2.2185535954609645,
            stride_length: 1.6287246302691227,
            loading_time: 0.10576923084014256,
            propulsion_time: 0.21153846168028512,
            flatfoot_time: 0.25961538478944046,
            walking_speed: 1.568401494763195,
            foot_progression_angle_FF: -0.6216153416682079,
            clearance: 0.010377995938873355,
            circumduction: 0.034231946461789065,
            plantar_flexion_angle_foot_in: -29.407606805544116,
            plantar_flexion_angle_foot_out: 50.13491182755017,
            step_by_step_angle: 4.026449550228244,
            cumulative_distance: 2.9524386265253644,
            time_foot_in: 2.9423077,
          },
          {
            swing_speed: 1.9954827026252209,
            step_by_step_cadence: 62.39999995816468,
            stance_time: 0.5769230773098677,
            gaitline_FFO: 2.351143831506227,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3942307694950764,
            pronation_angle_foot_in: -5.102546569742054,
            pronation_angle_FFI: -7.041055036840379,
            pronation_angle_FFO: -8.240101343429098,
            pronation_angle_foot_out: -1.863259439939923,
            propulsion_speed: 2.175884428420616,
            stride_length: 1.3341788211548344,
            loading_time: 0.09615384621831113,
            propulsion_time: 0.24038461554577806,
            flatfoot_time: 0.2403846155457785,
            walking_speed: 1.3875459730707644,
            foot_progression_angle_FF: 7.394753715147126,
            clearance: null,
            circumduction: -0.052286775166646246,
            plantar_flexion_angle_foot_in: -27.92533279424776,
            plantar_flexion_angle_foot_out: 60.1211101109943,
            step_by_step_angle: 4.539083055961865,
            cumulative_distance: 4.293392059779418,
            time_foot_in: 3.9134615,
          },
          {
            swing_speed: 2.0331023014322493,
            step_by_step_cadence: 63.03030298804513,
            stance_time: 0.5576923080662062,
            gaitline_FFO: 2.3107570093719274,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.7928713342297167,
            gaitline_FFI: 2.0,
            swing_time: 0.3653846156295826,
            pronation_angle_foot_in: -6.827134399967738,
            pronation_angle_FFI: -7.894372611478645,
            pronation_angle_FFO: -8.441933082112332,
            pronation_angle_foot_out: -6.032583514905321,
            propulsion_speed: 2.1929747075392956,
            stride_length: 1.3052318061897044,
            loading_time: 0.08653846159648015,
            propulsion_time: 0.2403846155457785,
            flatfoot_time: 0.23076923092394752,
            walking_speed: 1.3711526035628412,
            foot_progression_angle_FF: -0.45697903756910674,
            clearance: 0.0001035875334031433,
            circumduction: 0.017821507091654868,
            plantar_flexion_angle_foot_in: -31.690086955950605,
            plantar_flexion_angle_foot_out: 59.016250634451794,
            step_by_step_angle: 9.238830954274313,
            cumulative_distance: 5.60262727198901,
            time_foot_in: 4.8365385,
          },
          {
            swing_speed: 2.155873595295976,
            step_by_step_cadence: 63.673469345066,
            stance_time: 0.5865384619316991,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 2.758119525142469,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.4038461541169074,
            pronation_angle_foot_in: -6.206254471910632,
            pronation_angle_FFI: -9.033195284260616,
            pronation_angle_FFO: -7.980067728437393,
            pronation_angle_foot_out: 1.2287110869603155,
            propulsion_speed: 2.4017812115935,
            stride_length: 1.530937543762989,
            loading_time: 0.09615384621831158,
            propulsion_time: 0.25000000016760904,
            flatfoot_time: 0.2403846155457785,
            walking_speed: 1.6246684127000552,
            foot_progression_angle_FF: 4.467960153668946,
            clearance: 0.005329559265670823,
            circumduction: 0.016011128323467207,
            plantar_flexion_angle_foot_in: -28.10919712621028,
            plantar_flexion_angle_foot_out: 66.70195032322646,
            step_by_step_angle: 6.497299605656509,
            cumulative_distance: 7.145827219961755,
            time_foot_in: 5.8269231,
          },
          {
            swing_speed: 2.098988972970985,
            step_by_step_cadence: 59.99999995977373,
            stance_time: 0.5769230773098686,
            gaitline_FFO: 2.1047956039013678,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.8774725411619455,
            gaitline_FFI: 2.0,
            swing_time: 0.45192307722606273,
            pronation_angle_foot_in: -4.82328697519972,
            pronation_angle_FFI: -6.8840545640442095,
            pronation_angle_FFO: -9.471218041189655,
            pronation_angle_foot_out: -5.609791926276459,
            propulsion_speed: 1.9310299952271304,
            stride_length: 1.483776541682456,
            loading_time: 0.09615384621831158,
            propulsion_time: 0.23076923092394797,
            flatfoot_time: 0.25000000016760904,
            walking_speed: 1.4837765406876762,
            foot_progression_angle_FF: 0.04162052188674716,
            clearance: 0.01364908628273348,
            circumduction: 0.008400571934806221,
            plantar_flexion_angle_foot_in: -25.01486577424079,
            plantar_flexion_angle_foot_out: 48.48164733249836,
            step_by_step_angle: 5.123444196855466,
            cumulative_distance: 8.637927845874957,
            time_foot_in: 6.8557692,
          },
          {
            swing_speed: 1.9270119299646358,
            step_by_step_cadence: 55.714285676932754,
            stance_time: 0.6442307696626859,
            gaitline_FFO: null,
            gaitline_foot_in: null,
            gaitline_foot_out: null,
            gaitline_FFI: null,
            swing_time: 0.4038461541169074,
            pronation_angle_foot_in: null,
            pronation_angle_FFI: null,
            pronation_angle_FFO: -8.484902569748241,
            pronation_angle_foot_out: -5.889851363257119,
            propulsion_speed: 1.796506616086971,
            stride_length: 1.263804654867318,
            loading_time: 0.08653846159648015,
            propulsion_time: 0.25000000016760904,
            flatfoot_time: 0.3076923078985967,
            walking_speed: 1.173532893018586,
            foot_progression_angle_FF: null,
            clearance: 0.018063642422321426,
            circumduction: 0.060280084643873896,
            plantar_flexion_angle_foot_in: null,
            plantar_flexion_angle_foot_out: 51.789893963960026,
            step_by_step_angle: 13.07332273200869,
            cumulative_distance: 9.909341085526878,
            time_foot_in: 7.9038462,
          },
          {
            swing_speed: 1.7423668788576807,
            step_by_step_cadence: 50.731707283060715,
            stance_time: null,
            gaitline_FFO: 2.3298448441617756,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.4423076926042313,
            pronation_angle_foot_in: -5.88504218821882,
            pronation_angle_FFI: -6.551017496195556,
            pronation_angle_FFO: -8.34654229175694,
            pronation_angle_foot_out: null,
            propulsion_speed: 1.4180893108417223,
            stride_length: 1.3192527489638906,
            loading_time: null,
            propulsion_time: 0.269230769411271,
            flatfoot_time: null,
            walking_speed: 1.1154657382134878,
            foot_progression_angle_FF: -15.45458502318746,
            clearance: 0.0027409079365666444,
            circumduction: null,
            plantar_flexion_angle_foot_in: -24.999783215344113,
            plantar_flexion_angle_foot_out: 45.0363563692596,
            step_by_step_angle: 161.29891843307354,
            cumulative_distance: 11.231452706065577,
            time_foot_in: 9.1826923,
          },
          {
            swing_speed: 2.0985052630928944,
            step_by_step_cadence: 55.714285676932754,
            stance_time: 0.5865384619316991,
            gaitline_FFO: 2.423521584666594,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.7008237835722686,
            swing_time: 0.4038461541169074,
            pronation_angle_foot_in: -6.873572896697417,
            pronation_angle_FFI: -6.492587947265645,
            pronation_angle_FFO: -7.878396039808873,
            pronation_angle_foot_out: -3.763057538894102,
            propulsion_speed: 2.1864186425070256,
            stride_length: 1.3386928433436154,
            loading_time: 0.10576923084014389,
            propulsion_time: 0.2403846155457785,
            flatfoot_time: 0.24038461554577673,
            walking_speed: 1.2430719251285265,
            foot_progression_angle_FF: 0.7147022366913856,
            clearance: null,
            circumduction: 0.004273989726638329,
            plantar_flexion_angle_foot_in: -26.23394853072882,
            plantar_flexion_angle_foot_out: 56.79448341251084,
            step_by_step_angle: 14.039128805013675,
            cumulative_distance: 12.575713986913536,
            time_foot_in: 10.1730769,
          },
          {
            swing_speed: 2.0744558498961867,
            step_by_step_cadence: 59.99999995977373,
            stance_time: 0.6153846157971934,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.466547990289493,
            swing_time: 0.3750000002514149,
            pronation_angle_foot_in: -8.065707659990975,
            pronation_angle_FFI: -7.663373074464329,
            pronation_angle_FFO: -6.964009595039076,
            pronation_angle_foot_out: 1.328847187421851,
            propulsion_speed: 2.2278151164695856,
            stride_length: 1.4699908448416004,
            loading_time: 0.07692307697464962,
            propulsion_time: 0.269230769411271,
            flatfoot_time: 0.2692307694112728,
            walking_speed: 1.4699908438560627,
            foot_progression_angle_FF: 0.515130610900575,
            clearance: 0.006385913384523621,
            circumduction: 0.009655163744068909,
            plantar_flexion_angle_foot_in: -30.11484047787453,
            plantar_flexion_angle_foot_out: 68.57470112880023,
            step_by_step_angle: 2.6626937953857226,
            cumulative_distance: 14.056041951075066,
            time_foot_in: 11.1634615,
          },
          {
            swing_speed: 1.9887957904381188,
            step_by_step_cadence: 59.99999995977373,
            stance_time: 0.6153846157971916,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.544352913677334,
            gaitline_FFI: 2.0,
            swing_time: 0.35576923100775204,
            pronation_angle_foot_in: -3.656205808350557,
            pronation_angle_FFI: -6.833865821337727,
            pronation_angle_FFO: -8.846479716676546,
            pronation_angle_foot_out: -7.2745456764268095,
            propulsion_speed: 2.271402291718974,
            stride_length: 1.2797109111739857,
            loading_time: 0.09615384621831069,
            propulsion_time: 0.269230769411271,
            flatfoot_time: 0.2500000001676099,
            walking_speed: 1.2797109103160191,
            foot_progression_angle_FF: -6.840774413587352,
            clearance: null,
            circumduction: 0.020875072139406845,
            plantar_flexion_angle_foot_in: -29.527747327332612,
            plantar_flexion_angle_foot_out: 66.00605059841757,
            step_by_step_angle: 2.9361202690306967,
            cumulative_distance: 15.343768570196438,
            time_foot_in: 12.1346154,
          },
          {
            swing_speed: 2.105581459623059,
            step_by_step_cadence: 61.78217817640068,
            stance_time: 0.6153846157971916,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.6631447677446878,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3750000002514149,
            pronation_angle_foot_in: -6.680887518127276,
            pronation_angle_FFI: -7.22928848695518,
            pronation_angle_FFO: -8.187942666135712,
            pronation_angle_foot_out: -1.191572828615554,
            propulsion_speed: 2.345922335912612,
            stride_length: 1.4241103248230154,
            loading_time: 0.08653846159647927,
            propulsion_time: 0.2596153847894396,
            flatfoot_time: 0.2692307694112728,
            walking_speed: 1.4664106305177897,
            foot_progression_angle_FF: -8.820785026013432,
            clearance: 0.0034382934750882554,
            circumduction: 0.06155122628256894,
            plantar_flexion_angle_foot_in: -28.220270647388208,
            plantar_flexion_angle_foot_out: 64.81343451735185,
            step_by_step_angle: 10.12311239405551,
            cumulative_distance: 16.778765667275128,
            time_foot_in: 13.125,
          },
          {
            swing_speed: 2.080677201621715,
            step_by_step_cadence: 61.176470547220276,
            stance_time: 0.5865384619316991,
            gaitline_FFO: 2.376691650830625,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.4024834669843833,
            swing_time: 0.36538461562958346,
            pronation_angle_foot_in: -9.552467216888395,
            pronation_angle_FFI: -7.98353330107452,
            pronation_angle_FFO: -8.112427005085225,
            pronation_angle_foot_out: -2.62217248824375,
            propulsion_speed: 2.186074791053309,
            stride_length: 1.3679377339680165,
            loading_time: 0.09615384621831069,
            propulsion_time: 0.2403846155457785,
            flatfoot_time: 0.2500000001676099,
            walking_speed: 1.3947600415420935,
            foot_progression_angle_FF: 0.47943860815754663,
            clearance: 0.00114401995496137,
            circumduction: 0.01431509777299009,
            plantar_flexion_angle_foot_in: -29.786603494432494,
            plantar_flexion_angle_foot_out: 57.73412543923097,
            step_by_step_angle: 10.005237227129951,
            cumulative_distance: 18.15735576103862,
            time_foot_in: 14.0769231,
          },
          {
            swing_speed: 2.192730565170299,
            step_by_step_cadence: 61.176470547220276,
            stance_time: 0.6346153850408545,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.321987983009368,
            swing_time: 0.35576923100775204,
            pronation_angle_foot_in: -6.323505297239332,
            pronation_angle_FFI: -8.38580668205014,
            pronation_angle_FFO: -8.707706069220498,
            pronation_angle_foot_out: -2.511166220400851,
            propulsion_speed: 2.5498349067219515,
            stride_length: 1.4548854269925506,
            loading_time: 0.10576923084014211,
            propulsion_time: 0.269230769411271,
            flatfoot_time: 0.25961538478944135,
            walking_speed: 1.4834125912331626,
            foot_progression_angle_FF: 3.622297170438098,
            clearance: null,
            circumduction: -0.01747373077187372,
            plantar_flexion_angle_foot_in: -28.874242251241768,
            plantar_flexion_angle_foot_out: 69.87333380729854,
            step_by_step_angle: 4.9471403624860875,
            cumulative_distance: 19.62607476147037,
            time_foot_in: 15.0673077,
          },
          {
            swing_speed: 2.0619036100042916,
            step_by_step_cadence: 62.39999995816468,
            stance_time: 0.6153846157971916,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.341186345290163,
            swing_time: 0.3461538463859206,
            pronation_angle_foot_in: -7.419827562763121,
            pronation_angle_FFI: -8.289863534403654,
            pronation_angle_FFO: -8.873825042658696,
            pronation_angle_foot_out: -1.8523509384437304,
            propulsion_speed: 2.416298375096253,
            stride_length: 1.3027348878172482,
            loading_time: 0.10576923084014211,
            propulsion_time: 0.2596153847894396,
            flatfoot_time: 0.2500000001676099,
            walking_speed: 1.3548442824215992,
            foot_progression_angle_FF: -5.053586325613974,
            clearance: null,
            circumduction: 0.0481015495990497,
            plantar_flexion_angle_foot_in: -29.64428896843432,
            plantar_flexion_angle_foot_out: 73.14602766901717,
            step_by_step_angle: 2.2031514275989417,
            cumulative_distance: 20.938662656333264,
            time_foot_in: 16.0288462,
          },
          {
            swing_speed: 2.025763231780099,
            step_by_step_cadence: 63.03030298804513,
            stance_time: 0.5576923080662048,
            gaitline_FFO: 2.392882861512436,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3846153848732463,
            pronation_angle_foot_in: -7.817407324948157,
            pronation_angle_FFI: -7.3281359989725035,
            pronation_angle_FFO: -8.031511992945138,
            pronation_angle_foot_out: -2.78779082589903,
            propulsion_speed: 1.9060922123643185,
            stride_length: 1.3058388167079684,
            loading_time: 0.08653846159647927,
            propulsion_time: 0.23076923092394708,
            flatfoot_time: 0.2403846155457785,
            walking_speed: 1.3717902711775596,
            foot_progression_angle_FF: -2.258198312514743,
            clearance: 0.0038579565505026947,
            circumduction: 0.017308441001336244,
            plantar_flexion_angle_foot_in: -30.392591964339545,
            plantar_flexion_angle_foot_out: 51.0405505355689,
            step_by_step_angle: 7.929250725463697,
            cumulative_distance: 22.251533578527788,
            time_foot_in: 16.9711538,
          },
          {
            swing_speed: 2.1871285733501202,
            step_by_step_cadence: 63.03030298804513,
            stance_time: 0.5673076926880363,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 2.599977143024715,
            gaitline_foot_out: 2.62838527706485,
            gaitline_FFI: 2.0,
            swing_time: 0.4134615387387406,
            pronation_angle_foot_in: -6.996565525258582,
            pronation_angle_FFI: -7.118785433347226,
            pronation_angle_FFO: -8.621577205025233,
            pronation_angle_foot_out: -6.854596863624339,
            propulsion_speed: 2.0679606134768296,
            stride_length: 1.5674681216992212,
            loading_time: 0.09615384621831069,
            propulsion_time: 0.22115384630211565,
            flatfoot_time: 0.2500000001676099,
            walking_speed: 1.646633177246732,
            foot_progression_angle_FF: -3.61870155696754,
            clearance: 0.0208525824993699,
            circumduction: 0.03645793668402648,
            plantar_flexion_angle_foot_in: -28.143474691637817,
            plantar_flexion_angle_foot_out: 50.839780567377446,
            step_by_step_angle: 2.539282057672086,
            cumulative_distance: 23.83453805458948,
            time_foot_in: 17.9519231,
          },
          {
            swing_speed: 2.165223268785348,
            step_by_step_cadence: 59.428571388728265,
            stance_time: 0.6153846157971934,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.4273562984001082,
            swing_time: 0.42307692336056846,
            pronation_angle_foot_in: -6.659871097482494,
            pronation_angle_FFI: -7.8592321913234935,
            pronation_angle_FFO: -7.654273757591905,
            pronation_angle_foot_out: -3.129556588435605,
            propulsion_speed: 2.2498641596329465,
            stride_length: 1.5150512053183611,
            loading_time: 0.11538461546197354,
            propulsion_time: 0.2500000001676099,
            flatfoot_time: 0.2500000001676099,
            walking_speed: 1.500622145214017,
            foot_progression_angle_FF: -2.672692347490849,
            clearance: 0.01054772800592696,
            circumduction: 0.01856790460671337,
            plantar_flexion_angle_foot_in: -25.17921891017916,
            plantar_flexion_angle_foot_out: 57.03889306892242,
            step_by_step_angle: 5.6528638092700225,
            cumulative_distance: 25.361227280279426,
            time_foot_in: 18.9903846,
          },
          {
            swing_speed: 2.0814935021209098,
            step_by_step_cadence: 58.317756970247366,
            stance_time: 0.5865384619316991,
            gaitline_FFO: 2.118143202491146,
            gaitline_foot_in: 1.509371883401641,
            gaitline_foot_out: 2.8923228462392574,
            gaitline_FFI: 2.0,
            swing_time: 0.42307692336056846,
            pronation_angle_foot_in: -12.44682737143299,
            pronation_angle_FFI: -6.584033455466074,
            pronation_angle_FFO: -9.404513881559009,
            pronation_angle_foot_out: -5.535578043248885,
            propulsion_speed: 1.884819576831614,
            stride_length: 1.4705899310685666,
            loading_time: 0.08653846159647927,
            propulsion_time: 0.23076923092394708,
            flatfoot_time: 0.2692307694112728,
            walking_speed: 1.4293584367158247,
            foot_progression_angle_FF: 9.684663441854152,
            clearance: 0.004014669582622234,
            circumduction: -0.012700609036832325,
            plantar_flexion_angle_foot_in: -25.64188116390692,
            plantar_flexion_angle_foot_out: 50.55314682701855,
            step_by_step_angle: 1.8368308027271967,
            cumulative_distance: 26.840325727106585,
            time_foot_in: 20.0,
          },
          {
            swing_speed: null,
            step_by_step_cadence: null,
            stance_time: null,
            gaitline_FFO: null,
            gaitline_foot_in: null,
            gaitline_foot_out: null,
            gaitline_FFI: null,
            swing_time: null,
            pronation_angle_foot_in: null,
            pronation_angle_FFI: null,
            pronation_angle_FFO: null,
            pronation_angle_foot_out: null,
            propulsion_speed: null,
            stride_length: 1.4381903521836925,
            loading_time: null,
            propulsion_time: null,
            flatfoot_time: null,
            walking_speed: 0.6737468312019163,
            foot_progression_angle_FF: 5.591016924212741,
            clearance: null,
            circumduction: -0.024695585822127535,
            plantar_flexion_angle_foot_in: null,
            plantar_flexion_angle_foot_out: null,
            step_by_step_angle: 177.3120795886046,
            cumulative_distance: 28.28184941056952,
            time_foot_in: null,
          },
          {
            swing_speed: 2.2673389350379836,
            step_by_step_cadence: 57.77777773904137,
            stance_time: 0.5769230773098677,
            gaitline_FFO: 2.2907036751413754,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.8556762210948703,
            gaitline_FFI: 2.0,
            swing_time: 0.38461538487324276,
            pronation_angle_foot_in: -9.28119376989884,
            pronation_angle_FFI: -8.839252329476276,
            pronation_angle_FFO: -8.542148922335892,
            pronation_angle_foot_out: -5.718718277584945,
            propulsion_speed: 2.3036199811825595,
            stride_length: 1.4974400102483898,
            loading_time: 0.07692307697464784,
            propulsion_time: 0.23076923092394708,
            flatfoot_time: 0.2692307694112728,
            walking_speed: 1.4419792681613217,
            foot_progression_angle_FF: -5.620556602992335,
            clearance: 0.007847976053184366,
            circumduction: 0.06351143787280719,
            plantar_flexion_angle_foot_in: -28.847505025103533,
            plantar_flexion_angle_foot_out: 58.9630746324676,
            step_by_step_angle: 5.369162092566195,
            cumulative_distance: 29.78961629864285,
            time_foot_in: 23.1634615,
          },
          {
            swing_speed: 2.258163165749417,
            step_by_step_cadence: 61.78217817640068,
            stance_time: 0.5576923080662084,
            gaitline_FFO: 2.1841174049119436,
            gaitline_foot_in: 1.8397488207419368,
            gaitline_foot_out: 2.88739613260184,
            gaitline_FFI: 2.0,
            swing_time: 0.41346153873873703,
            pronation_angle_foot_in: -10.795780119869132,
            pronation_angle_FFI: -7.263232625618926,
            pronation_angle_FFO: -9.074810100000011,
            pronation_angle_foot_out: -5.560199123266711,
            propulsion_speed: 1.8775444615038714,
            stride_length: 1.5739851244825296,
            loading_time: 0.08653846159648282,
            propulsion_time: 0.23076923092394708,
            flatfoot_time: 0.2403846155457785,
            walking_speed: 1.6207371567963973,
            foot_progression_angle_FF: 3.7658696550002837,
            clearance: 0.013819216756699726,
            circumduction: 0.010304992890958625,
            plantar_flexion_angle_foot_in: -29.202702866432293,
            plantar_flexion_angle_foot_out: 48.93090139007639,
            step_by_step_angle: 4.86074965353269,
            cumulative_distance: 31.38033486037717,
            time_foot_in: 24.1346154,
          },
          {
            swing_speed: 1.9917565949392504,
            step_by_step_cadence: 60.58252423122784,
            stance_time: 0.5961538465535305,
            gaitline_FFO: 2.264784015068054,
            gaitline_foot_in: 2.0475470794463932,
            gaitline_foot_out: 2.543641508491035,
            gaitline_FFI: 2.0,
            swing_time: 0.3846153848732463,
            pronation_angle_foot_in: -9.757315550653866,
            pronation_angle_FFI: -7.665771215919254,
            pronation_angle_FFO: -8.671681521887317,
            pronation_angle_foot_out: -7.278100899097747,
            propulsion_speed: 2.062218491988151,
            stride_length: 1.338187922111338,
            loading_time: 0.08653846159647927,
            propulsion_time: 0.2403846155457785,
            flatfoot_time: 0.2692307694112728,
            walking_speed: 1.3511800369541096,
            foot_progression_angle_FF: 4.9697649033823925,
            clearance: null,
            circumduction: -0.009106100769445276,
            plantar_flexion_angle_foot_in: -28.589880500765524,
            plantar_flexion_angle_foot_out: 55.811732412448144,
            step_by_step_angle: 5.684190341326174,
            cumulative_distance: 32.7318154858095,
            time_foot_in: 25.1153846,
          },
          {
            swing_speed: 1.7517756229614874,
            step_by_step_cadence: 59.428571388728265,
            stance_time: 0.6442307696626841,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.4181079004265786,
            swing_time: 0.39423076949507774,
            pronation_angle_foot_in: -5.901750317113278,
            pronation_angle_FFI: -7.905450738472979,
            pronation_angle_FFO: -8.335634768133941,
            pronation_angle_foot_out: -4.916072069879914,
            propulsion_speed: 1.8163162367440597,
            stride_length: 1.2264932047550872,
            loading_time: 0.09615384621831069,
            propulsion_time: 0.25961538478944135,
            flatfoot_time: 0.28846153865493207,
            walking_speed: 1.214812316276297,
            foot_progression_angle_FF: 0.8966131590429757,
            clearance: 0.0010057019985336632,
            circumduction: 0.003293543433510887,
            plantar_flexion_angle_foot_in: -26.54465579650007,
            plantar_flexion_angle_foot_out: 56.28437061947559,
            step_by_step_angle: 6.083311750135278,
            cumulative_distance: 33.963461705057405,
            time_foot_in: 26.1538462,
          },
          {
            swing_speed: 2.2628614512657808,
            step_by_step_cadence: 58.8679244888346,
            stance_time: 0.6250000004190213,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.627648193266933,
            swing_time: 0.36538461562958346,
            pronation_angle_foot_in: -6.778554145895714,
            pronation_angle_FFI: -6.858280414263557,
            pronation_angle_FFO: -8.912966503352422,
            pronation_angle_foot_out: -3.11653767682177,
            propulsion_speed: 2.38350937977076,
            stride_length: 1.5076340698304733,
            loading_time: 0.09615384621831069,
            propulsion_time: 0.2500000001676064,
            flatfoot_time: 0.2788461540331042,
            walking_speed: 1.4791881429929115,
            foot_progression_angle_FF: 1.2049478967269731,
            clearance: null,
            circumduction: 0.01482504413982183,
            plantar_flexion_angle_foot_in: -28.17068347860638,
            plantar_flexion_angle_foot_out: 64.12221781667114,
            step_by_step_angle: 0.368857212627859,
            cumulative_distance: 35.48010037778474,
            time_foot_in: 27.1442308,
          },
          {
            swing_speed: 2.263850218290002,
            step_by_step_cadence: 63.03030298804513,
            stance_time: 0.5576923080662084,
            gaitline_FFO: 2.477273043113548,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.4038461541169056,
            pronation_angle_foot_in: -7.124096021613406,
            pronation_angle_FFI: -7.460019732264102,
            pronation_angle_FFO: -7.609774996067608,
            pronation_angle_foot_out: -3.95563266503936,
            propulsion_speed: 2.215638964837898,
            stride_length: 1.5913651559393145,
            loading_time: 0.08653846159648282,
            propulsion_time: 0.2403846155457785,
            flatfoot_time: 0.23076923092394708,
            walking_speed: 1.6717371323912111,
            foot_progression_angle_FF: -5.873284755988037,
            clearance: 0.005175594804035805,
            circumduction: 0.04468255112727186,
            plantar_flexion_angle_foot_in: -28.532675212808673,
            plantar_flexion_angle_foot_out: 59.99830967570967,
            step_by_step_angle: 6.0169860586946085,
            cumulative_distance: 37.089301239044204,
            time_foot_in: 28.1057692,
          },
          {
            swing_speed: 2.1071265029293342,
            step_by_step_cadence: 60.58252423122784,
            stance_time: 0.5769230773098677,
            gaitline_FFO: 2.3508761887084493,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.9864309406960228,
            gaitline_FFI: 2.0,
            swing_time: 0.423076923360572,
            pronation_angle_foot_in: -6.675988360308282,
            pronation_angle_FFI: -7.825005688440484,
            pronation_angle_FFO: -8.241438879000524,
            pronation_angle_foot_out: -5.065276114931436,
            propulsion_speed: 2.123832820698442,
            stride_length: 1.409471959773093,
            loading_time: 0.08653846159647927,
            propulsion_time: 0.23076923092394708,
            flatfoot_time: 0.25961538478944135,
            walking_speed: 1.42315615260316,
            foot_progression_angle_FF: 1.3155989679175526,
            clearance: 0.0066915603853555106,
            circumduction: -0.0036405520292112884,
            plantar_flexion_angle_foot_in: -27.275599809994265,
            plantar_flexion_angle_foot_out: 51.257361312189325,
            step_by_step_angle: 1.3228876877624882,
            cumulative_distance: 38.507660553820486,
            time_foot_in: 29.1057692,
          },
          {
            swing_speed: 2.27311193207637,
            step_by_step_cadence: 60.58252423122784,
            stance_time: 0.5673076926880363,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.542045420700696,
            swing_time: 0.42307692336056846,
            pronation_angle_foot_in: -7.7380790464296325,
            pronation_angle_FFI: -7.286077292306998,
            pronation_angle_FFO: -8.568031927019138,
            pronation_angle_foot_out: -4.172200898622804,
            propulsion_speed: 2.0725420798249545,
            stride_length: 1.4682091930659595,
            loading_time: 0.08653846159647927,
            propulsion_time: 0.20192307705845636,
            flatfoot_time: 0.27884615403310065,
            walking_speed: 1.4824636502571664,
            foot_progression_angle_FF: 0.9388790805241966,
            clearance: 0.010638453234140921,
            circumduction: 0.014417477740248352,
            plantar_flexion_angle_foot_in: -27.74943028317617,
            plantar_flexion_angle_foot_out: 49.71677428349042,
            step_by_step_angle: 1.0568923258419707,
            cumulative_distance: 39.98169657239942,
            time_foot_in: 30.0961538,
          },
          {
            swing_speed: 2.1851525325535315,
            step_by_step_cadence: 60.58252423122784,
            stance_time: 0.605769231175362,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.798355829375838,
            gaitline_FFI: 2.35635777907886,
            swing_time: 0.4038461541169056,
            pronation_angle_foot_in: -7.167298032768304,
            pronation_angle_FFI: -8.214044821812012,
            pronation_angle_FFO: -8.97892470964916,
            pronation_angle_foot_out: -6.005174941201243,
            propulsion_speed: 2.546683054661753,
            stride_length: 1.5052202484409278,
            loading_time: 0.07692307697464784,
            propulsion_time: 0.25961538478944135,
            flatfoot_time: 0.2692307694112728,
            walking_speed: 1.5198340362417884,
            foot_progression_angle_FF: -1.7917770898284322,
            clearance: 0.008706359159959154,
            circumduction: 0.018345913060340686,
            plantar_flexion_angle_foot_in: -26.65971693242945,
            plantar_flexion_angle_foot_out: 68.11752083132626,
            step_by_step_angle: 5.582767168449375,
            cumulative_distance: 41.49447654285869,
            time_foot_in: 31.1057692,
          },
          {
            swing_speed: 1.7156720831349372,
            step_by_step_cadence: 58.8679244888346,
            stance_time: 0.5769230773098712,
            gaitline_FFO: 2.310130524868707,
            gaitline_foot_in: 1.538512857009567,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.45192307722606273,
            pronation_angle_foot_in: -12.301196369551937,
            pronation_angle_FFI: -7.566681891215167,
            pronation_angle_FFO: -8.445063916623711,
            pronation_angle_foot_out: -4.240421617540501,
            propulsion_speed: 1.7328337282606163,
            stride_length: 1.4361521575648695,
            loading_time: 0.09615384621831424,
            propulsion_time: 0.23076923092394708,
            flatfoot_time: 0.2500000001676099,
            walking_speed: 1.4090549461000939,
            foot_progression_angle_FF: 15.657155278173697,
            clearance: 0.029655795086630833,
            circumduction: 0.017947258375080242,
            plantar_flexion_angle_foot_in: -22.45998620071864,
            plantar_flexion_angle_foot_out: 48.047921675841444,
            step_by_step_angle: 4.481779761251912,
            cumulative_distance: 42.93962837849723,
            time_foot_in: 32.1346154,
          },
          {
            swing_speed: null,
            step_by_step_cadence: null,
            stance_time: null,
            gaitline_FFO: null,
            gaitline_foot_in: null,
            gaitline_foot_out: null,
            gaitline_FFI: null,
            swing_time: null,
            pronation_angle_foot_in: null,
            pronation_angle_FFI: null,
            pronation_angle_FFO: null,
            pronation_angle_foot_out: null,
            propulsion_speed: null,
            stride_length: 1.4207195931855239,
            loading_time: null,
            propulsion_time: null,
            flatfoot_time: null,
            walking_speed: 0.6808978690886361,
            foot_progression_angle_FF: 3.1347296109039844,
            clearance: null,
            circumduction: -0.01398291792871124,
            plantar_flexion_angle_foot_in: null,
            plantar_flexion_angle_foot_out: null,
            step_by_step_angle: 179.05096542448848,
            cumulative_distance: 44.36577519408698,
            time_foot_in: null,
          },
          {
            swing_speed: 2.135815619848946,
            step_by_step_cadence: 55.714285676932754,
            stance_time: 0.6442307696626841,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.704959501130845,
            gaitline_FFI: 2.206249089537881,
            swing_time: 0.3942307694950742,
            pronation_angle_foot_in: -6.193966167690824,
            pronation_angle_FFI: -8.964207775974911,
            pronation_angle_FFO: -8.30176227307382,
            pronation_angle_foot_out: -6.471919842635512,
            propulsion_speed: 2.391613730085645,
            stride_length: 1.5180572789159754,
            loading_time: 0.10576923084013856,
            propulsion_time: 0.2500000001676099,
            flatfoot_time: 0.2884615386549356,
            walking_speed: 1.4096246151911973,
            foot_progression_angle_FF: -3.0997648421320143,
            clearance: 0.02412568931211368,
            circumduction: 0.036746780519975576,
            plantar_flexion_angle_foot_in: -26.60697877854548,
            plantar_flexion_angle_foot_out: 68.99216404603392,
            step_by_step_angle: 1.3892396666578664,
            cumulative_distance: 45.894598559434215,
            time_foot_in: 35.2980769,
          },
          {
            swing_speed: 2.2122236221978286,
            step_by_step_cadence: 58.317756970247366,
            stance_time: 0.6057692311753655,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 2.8887455656370475,
            gaitline_FFI: 2.426657439307564,
            swing_time: 0.37500000025141134,
            pronation_angle_foot_in: -8.30841274857701,
            pronation_angle_FFI: -7.862724715327332,
            pronation_angle_FFO: -9.023369461501781,
            pronation_angle_foot_out: -5.553455378615874,
            propulsion_speed: 2.303360025964951,
            stride_length: 1.5481757603855897,
            loading_time: 0.10576923084014567,
            propulsion_time: 0.25961538478944135,
            flatfoot_time: 0.2403846155457785,
            walking_speed: 1.5047689623565792,
            foot_progression_angle_FF: -6.89084872240601,
            clearance: 0.00011205261623339208,
            circumduction: 0.03319221910142949,
            plantar_flexion_angle_foot_in: -30.837165127473586,
            plantar_flexion_angle_foot_out: 61.88642859604042,
            step_by_step_angle: 1.3155765532183992,
            cumulative_distance: 47.45570461533927,
            time_foot_in: 36.2788462,
          },
          {
            swing_speed: 2.090653728913926,
            step_by_step_cadence: 60.58252423122784,
            stance_time: 0.6153846157971969,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.6102009963775226,
            swing_time: 0.37500000025141134,
            pronation_angle_foot_in: -7.274668085748098,
            pronation_angle_FFI: -6.94547217378424,
            pronation_angle_FFO: -8.505036989000605,
            pronation_angle_foot_out: -3.120038562807859,
            propulsion_speed: 2.345125669646054,
            stride_length: 1.3849651973791737,
            loading_time: 0.09615384621831424,
            propulsion_time: 0.2500000001676099,
            flatfoot_time: 0.2692307694112728,
            walking_speed: 1.3984114604938507,
            foot_progression_angle_FF: -6.9174201219914435,
            clearance: 0.0006612242317026729,
            circumduction: 0.05038328614945183,
            plantar_flexion_angle_foot_in: -28.66386625707746,
            plantar_flexion_angle_foot_out: 65.12511030211972,
            step_by_step_angle: 9.742847816899692,
            cumulative_distance: 48.8517503904375,
            time_foot_in: 37.2692308,
          },
          {
            swing_speed: 2.021125119244937,
            step_by_step_cadence: 61.176470547220276,
            stance_time: 0.6153846157971898,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.475952306017328,
            swing_time: 0.365384615629587,
            pronation_angle_foot_in: -7.801160306832442,
            pronation_angle_FFI: -7.6163753337616,
            pronation_angle_FFO: -7.506541912341325,
            pronation_angle_foot_out: 1.5852305678453236,
            propulsion_speed: 2.2837599909486848,
            stride_length: 1.37288421619062,
            loading_time: 0.09615384621831424,
            propulsion_time: 0.2692307694112728,
            flatfoot_time: 0.2500000001676028,
            walking_speed: 1.3998035136088176,
            foot_progression_angle_FF: 5.172454883950425,
            clearance: null,
            circumduction: -0.010344082239904764,
            plantar_flexion_angle_foot_in: -28.848667255156244,
            plantar_flexion_angle_foot_out: 65.17632361510516,
            step_by_step_angle: 13.046713362504015,
            cumulative_distance: 50.234942791757085,
            time_foot_in: 38.25,
          },
          {
            swing_speed: 1.7930331694395798,
            step_by_step_cadence: 58.8679244888346,
            stance_time: 0.6538461542845155,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.3767196548782845,
            swing_time: 0.41346153873873703,
            pronation_angle_foot_in: -9.772118426773593,
            pronation_angle_FFI: -8.11228705583122,
            pronation_angle_FFO: -9.193330027280297,
            pronation_angle_foot_out: -1.3866427564864525,
            propulsion_speed: 1.9443586909849027,
            stride_length: 1.3469532501245638,
            loading_time: 0.09615384621830714,
            propulsion_time: 0.2692307694112728,
            flatfoot_time: 0.2884615386549356,
            walking_speed: 1.3215390369720528,
            foot_progression_angle_FF: -3.740560921852388,
            clearance: 0.007801547210992264,
            circumduction: 0.05850563848456033,
            plantar_flexion_angle_foot_in: -25.03063983523709,
            plantar_flexion_angle_foot_out: 61.6588290529986,
            step_by_step_angle: 3.1344852387038684,
            cumulative_distance: 51.59076162429613,
            time_foot_in: 39.3173077,
          },
          {
            swing_speed: null,
            step_by_step_cadence: 52.88135589674973,
            stance_time: null,
            gaitline_FFO: null,
            gaitline_foot_in: null,
            gaitline_foot_out: null,
            gaitline_FFI: null,
            swing_time: null,
            pronation_angle_foot_in: null,
            pronation_angle_FFI: null,
            pronation_angle_FFO: null,
            pronation_angle_foot_out: null,
            propulsion_speed: null,
            stride_length: null,
            loading_time: null,
            propulsion_time: null,
            flatfoot_time: null,
            walking_speed: null,
            foot_progression_angle_FF: -11.472473690280319,
            clearance: null,
            circumduction: 0.020892167359907385,
            plantar_flexion_angle_foot_in: null,
            plantar_flexion_angle_foot_out: null,
            step_by_step_angle: 1.2372786428352953,
            cumulative_distance: 52.028792826048225,
            time_foot_in: null,
          },
        ],
        debug: {
          segmented_activity: 37,
          recognized_step: 37,
          analysed_step: 34,
          saturation_percent: 0.0,
          frequency_used: 103.99999993027447,
          frequency_flag: false,
          g_flag: false,
          acc_coef: 0.244,
          gyr_coef: 0.07,
          noisy_data: false,
          last_timestamp: 45.9038462,
          line_removed: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          firewall: {
            aggregate_swing_speed: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_step_by_step_cadence: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_stance_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': true,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_gaitline_FFO: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_gaitline_foot_in: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_gaitline_foot_out: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_gaitline_FFI: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_swing_time: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_pronation_angle_foot_in: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_pronation_angle_FFI: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_pronation_angle_FFO: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_pronation_angle_foot_out: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': true,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_propulsion_speed: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_stride_length: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_loading_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': true,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_propulsion_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_flatfoot_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': true,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_walking_speed: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_foot_progression_angle_FF: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_clearance: {
              '0': true,
              '1': false,
              '2': true,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': true,
              '9': false,
              '10': true,
              '11': false,
              '12': false,
              '13': true,
              '14': true,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': true,
              '23': false,
              '24': true,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': true,
              '35': false,
              '36': true,
            },
            aggregate_circumduction: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': true,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_plantar_flexion_angle_foot_in: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            aggregate_plantar_flexion_angle_foot_out: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            degraded: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_init: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            sole_length_find_peaks: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            max_1_clearance: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            max_2_clearance: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            clearance_1: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            clearance_2: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            clearance_3: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            circumdunction: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            circumdunction_FPA: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_events: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_swing_time: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_stance_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            analysis: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            analysis_init: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            gyro_cross_up: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            gyro_cross_down: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            index_FFI: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            nan_in_index: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            order_index: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': true,
            },
            swing_time: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            nan_last_step: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            nan_in_main_variables: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            values_in_main_variables: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
          },
        },
      },
      right: {
        step_count: 36,
        distance: 51.34756353970833,
        cadence_global: 58.77800418105949,
        aggregates: {
          swing_speed: {
            avg: 1.996,
            std: 0.179,
          },
          step_by_step_cadence: {
            avg: 60.806,
            std: 2.28,
          },
          stance_time: {
            avg: 0.597,
            std: 0.032,
          },
          gaitline_FFO: {
            avg: 2.007,
            std: 0.043,
          },
          gaitline_foot_in: {
            avg: 1.39,
            std: 0.711,
          },
          gaitline_foot_out: {
            avg: 3.0,
            std: 0.0,
          },
          gaitline_FFI: {
            avg: 2.146,
            std: 0.329,
          },
          swing_time: {
            avg: 0.386,
            std: 0.018,
          },
          pronation_angle_foot_in: {
            avg: -11.902,
            std: 1.648,
          },
          pronation_angle_FFI: {
            avg: -5.99,
            std: 0.934,
          },
          pronation_angle_FFO: {
            avg: -6.843,
            std: 0.743,
          },
          pronation_angle_foot_out: {
            avg: 2.796,
            std: 2.814,
          },
          propulsion_speed: {
            avg: 1.943,
            std: 0.192,
          },
          stride_length: {
            avg: 1.39,
            std: 0.113,
          },
          loading_time: {
            avg: 0.121,
            std: 0.016,
          },
          propulsion_time: {
            avg: 0.226,
            std: 0.012,
          },
          flatfoot_time: {
            avg: 0.252,
            std: 0.028,
          },
          walking_speed: {
            avg: 1.394,
            std: 0.168,
          },
          foot_progression_angle_FF: {
            avg: 7.68,
            std: 4.858,
          },
          clearance: {
            avg: 0.01,
            std: 0.007,
          },
          circumduction: {
            avg: 0.015,
            std: 0.02,
          },
          plantar_flexion_angle_foot_in: {
            avg: -27.931,
            std: 3.13,
          },
          plantar_flexion_angle_foot_out: {
            avg: 53.395,
            std: 3.365,
          },
        },
        steps: [
          {
            swing_speed: 2.079251999305487,
            step_by_step_cadence: null,
            stance_time: null,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.36538461563160096,
            pronation_angle_foot_in: -14.527710770610305,
            pronation_angle_FFI: -5.433710085321716,
            pronation_angle_FFO: -6.99580448859592,
            pronation_angle_foot_out: 7.437709951092565,
            propulsion_speed: 2.0637987258822204,
            stride_length: 1.462219381176883,
            loading_time: null,
            propulsion_time: null,
            flatfoot_time: null,
            walking_speed: null,
            foot_progression_angle_FF: 8.076498946476466,
            clearance: null,
            circumduction: 0.021088762838184685,
            plantar_flexion_angle_foot_in: -26.65430322030272,
            plantar_flexion_angle_foot_out: 58.584397672956484,
            step_by_step_angle: 6.442601624146593,
            cumulative_distance: 1.462219381176883,
            time_foot_in: 2.4615385,
          },
          {
            swing_speed: 2.0297702172244247,
            step_by_step_cadence: 62.39999995782002,
            stance_time: 0.5576923080692864,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3942307694972538,
            pronation_angle_foot_in: -9.105534467782498,
            pronation_angle_FFI: -7.5114716348932875,
            pronation_angle_FFO: -6.3048043250025065,
            pronation_angle_foot_out: 4.508233718822773,
            propulsion_speed: 1.861108147397664,
            stride_length: 1.371617013899632,
            loading_time: 0.12500000008449552,
            propulsion_time: 0.21153846168145352,
            flatfoot_time: 0.22115384630333734,
            walking_speed: 1.426481693491371,
            foot_progression_angle_FF: 4.378091371433125,
            clearance: 0.009209755199133834,
            circumduction: 0.012734105701201372,
            plantar_flexion_angle_foot_in: -27.507465036280138,
            plantar_flexion_angle_foot_out: 55.01753860748879,
            step_by_step_angle: 2.8460881457382987,
            cumulative_distance: 2.8439998609107793,
            time_foot_in: 3.4134615,
          },
          {
            swing_speed: 2.2899078382600435,
            step_by_step_cadence: 63.673469344714306,
            stance_time: 0.5576923080692859,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3750000002534857,
            pronation_angle_foot_in: -13.069357446719144,
            pronation_angle_FFI: -5.594954106028406,
            pronation_angle_FFO: -6.73477487921986,
            pronation_angle_foot_out: 7.732167664833657,
            propulsion_speed: 1.8433232589296789,
            stride_length: 1.5551615099294436,
            loading_time: 0.1153846154626108,
            propulsion_time: 0.2307692309252216,
            flatfoot_time: 0.21153846168145352,
            walking_speed: 1.650375478809534,
            foot_progression_angle_FF: 4.94755958867248,
            clearance: 0.0036562875588877497,
            circumduction: 0.03428844075546776,
            plantar_flexion_angle_foot_in: -29.739775724064838,
            plantar_flexion_angle_foot_out: 52.00500664797314,
            step_by_step_angle: 11.563641424930426,
            cumulative_distance: 4.412192708777245,
            time_foot_in: 4.3461538,
          },
          {
            swing_speed: 1.9714657630370103,
            step_by_step_cadence: 63.673469344714306,
            stance_time: 0.5576923080692859,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 2.031748000501911,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.99760115444061,
            swing_time: 0.37500000025348523,
            pronation_angle_foot_in: -9.836270898077705,
            pronation_angle_FFI: -5.00945336032013,
            pronation_angle_FFO: -6.618468922052112,
            pronation_angle_foot_out: 3.0301899799044505,
            propulsion_speed: 1.8821675594846095,
            stride_length: 1.3777182439038498,
            loading_time: 0.09615384621884182,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.24038461554710633,
            walking_speed: 1.4620683394810903,
            foot_progression_angle_FF: 4.835037421646558,
            clearance: 0.0006747424296182913,
            circumduction: 0.004039421335847676,
            plantar_flexion_angle_foot_in: -27.422473298488235,
            plantar_flexion_angle_foot_out: 55.388149583564264,
            step_by_step_angle: 0.7939255387702185,
            cumulative_distance: 5.799069420277871,
            time_foot_in: 5.2788462,
          },
          {
            swing_speed: 2.0169722079863304,
            step_by_step_cadence: 62.39999995782002,
            stance_time: 0.6057692311787077,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.38461538487536906,
            pronation_angle_foot_in: -10.219202282500765,
            pronation_angle_FFI: -5.287900240077433,
            pronation_angle_FFO: -5.559652946497102,
            pronation_angle_foot_out: 5.235591639927109,
            propulsion_speed: 2.103235049062928,
            stride_length: 1.3564920099547653,
            loading_time: 0.1346153847063798,
            propulsion_time: 0.24038461554710633,
            flatfoot_time: 0.2307692309252216,
            walking_speed: 1.4107516893993426,
            foot_progression_angle_FF: 6.139580762761328,
            clearance: 0.0012064005747402795,
            circumduction: 0.017700738073777245,
            plantar_flexion_angle_foot_in: -27.71033094986919,
            plantar_flexion_angle_foot_out: 61.643454422267695,
            step_by_step_angle: 1.5173307031333203,
            cumulative_distance: 7.160122209412677,
            time_foot_in: 6.2692308,
          },
          {
            swing_speed: 1.8337381985751662,
            step_by_step_cadence: 59.99999995944233,
            stance_time: 0.6153846158005916,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.42307692336290703,
            pronation_angle_foot_in: -13.987767021792076,
            pronation_angle_FFI: -4.510155790722538,
            pronation_angle_FFO: -5.937129190168769,
            pronation_angle_foot_out: 4.691105784764917,
            propulsion_speed: 1.6618928791892067,
            stride_length: 1.3424035188229997,
            loading_time: 0.10576923084072654,
            propulsion_time: 0.24038461554710544,
            flatfoot_time: 0.2692307694127596,
            walking_speed: 1.3424035179155869,
            foot_progression_angle_FF: 24.970638374941608,
            clearance: 0.006410313267953202,
            circumduction: -0.02313199885579091,
            plantar_flexion_angle_foot_in: -26.0726954491789,
            plantar_flexion_angle_foot_out: 50.21491156207643,
            step_by_step_angle: 0.2211000336188514,
            cumulative_distance: 8.5074081248699,
            time_foot_in: 7.3076923,
          },
          {
            swing_speed: null,
            step_by_step_cadence: null,
            stance_time: null,
            gaitline_FFO: null,
            gaitline_foot_in: null,
            gaitline_foot_out: null,
            gaitline_FFI: null,
            swing_time: null,
            pronation_angle_foot_in: null,
            pronation_angle_FFI: null,
            pronation_angle_FFO: null,
            pronation_angle_foot_out: null,
            propulsion_speed: null,
            stride_length: 1.4277113912997397,
            loading_time: null,
            propulsion_time: null,
            flatfoot_time: null,
            walking_speed: null,
            foot_progression_angle_FF: 7.279268120513223,
            clearance: null,
            circumduction: 0.008760558064308253,
            plantar_flexion_angle_foot_in: null,
            plantar_flexion_angle_foot_out: null,
            step_by_step_angle: 178.68833380103695,
            cumulative_distance: 9.936869351291731,
            time_foot_in: null,
          },
          {
            swing_speed: 2.0620118890440025,
            step_by_step_cadence: 60.58252423089322,
            stance_time: 0.5865384619349392,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 2.2550455897607784,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.5687521835590195,
            swing_time: 0.42307692336290614,
            pronation_angle_foot_in: -8.720348963590661,
            pronation_angle_FFI: -7.1526111739684,
            pronation_angle_FFO: -7.361291240800927,
            pronation_angle_foot_out: 2.880998911626837,
            propulsion_speed: 2.1158900128678133,
            stride_length: 1.4313582360417794,
            loading_time: 0.12500000008449597,
            propulsion_time: 0.2307692309252225,
            flatfoot_time: 0.23076923092522073,
            walking_speed: 1.4452549169681614,
            foot_progression_angle_FF: 4.224868006377213,
            clearance: 0.025681706260762563,
            circumduction: 0.007896499343308744,
            plantar_flexion_angle_foot_in: -24.25998426146655,
            plantar_flexion_angle_foot_out: 52.372858408896626,
            step_by_step_angle: 1.965160657464638,
            cumulative_distance: 11.376594676836454,
            time_foot_in: 10.5769231,
          },
          {
            swing_speed: 2.115121586253239,
            step_by_step_cadence: 59.99999995944233,
            stance_time: 0.5769230773130545,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.9254048921938725,
            swing_time: 0.3942307694972538,
            pronation_angle_foot_in: -10.76257249587389,
            pronation_angle_FFI: -5.370251669413,
            pronation_angle_FFO: -7.8158696285625195,
            pronation_angle_foot_out: 2.455398827055158,
            propulsion_speed: 2.123148164449461,
            stride_length: 1.3953735571066694,
            loading_time: 0.0961538462188436,
            propulsion_time: 0.23076923092522073,
            flatfoot_time: 0.25000000016899016,
            walking_speed: 1.3953735561634508,
            foot_progression_angle_FF: 6.397686327919636,
            clearance: 0.006159824239305417,
            circumduction: 0.036014227641740906,
            plantar_flexion_angle_foot_in: -24.43260321634626,
            plantar_flexion_angle_foot_out: 53.523947027052536,
            step_by_step_angle: 6.568611093445966,
            cumulative_distance: 12.776248936572738,
            time_foot_in: 11.5480769,
          },
          {
            swing_speed: 1.9919332352807124,
            step_by_step_cadence: 62.39999995782002,
            stance_time: 0.5576923080692868,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.38461538487536906,
            pronation_angle_foot_in: -13.506120206639507,
            pronation_angle_FFI: -5.325005770064376,
            pronation_angle_FFO: -5.966272671771703,
            pronation_angle_foot_out: 3.5131470439930745,
            propulsion_speed: 1.8472444340478933,
            stride_length: 1.333310274813007,
            loading_time: 0.08653846159695888,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.25000000016899016,
            walking_speed: 1.3866426848682107,
            foot_progression_angle_FF: 18.50485488541777,
            clearance: 0.009507828357453993,
            circumduction: -0.04190052420604082,
            plantar_flexion_angle_foot_in: -28.42078637994961,
            plantar_flexion_angle_foot_out: 47.00901713225643,
            step_by_step_angle: 0.1981920294180251,
            cumulative_distance: 14.117299681581395,
            time_foot_in: 12.4903846,
          },
          {
            swing_speed: 2.037566361166689,
            step_by_step_cadence: 61.782178176059425,
            stance_time: 0.5961538465568239,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3653846156316014,
            pronation_angle_foot_in: -12.945478416537968,
            pronation_angle_FFI: -5.422979771442122,
            pronation_angle_FFO: -6.973416109815535,
            pronation_angle_foot_out: 0.9924617705152652,
            propulsion_speed: 2.022358202446027,
            stride_length: 1.4011644556510845,
            loading_time: 0.10576923084072654,
            propulsion_time: 0.2307692309252225,
            flatfoot_time: 0.25961538479087487,
            walking_speed: 1.442783200883277,
            foot_progression_angle_FF: 6.961345328274395,
            clearance: null,
            circumduction: 0.00561334392966599,
            plantar_flexion_angle_foot_in: -28.873645959928815,
            plantar_flexion_angle_foot_out: 55.39076390815007,
            step_by_step_angle: 15.149009531763665,
            cumulative_distance: 15.527147354756492,
            time_foot_in: 13.4519231,
          },
          {
            swing_speed: 1.977513276492161,
            step_by_step_cadence: 63.03030298769699,
            stance_time: 0.5769230773130545,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3942307694972538,
            pronation_angle_foot_in: -12.833040973949245,
            pronation_angle_FFI: -5.978387359079922,
            pronation_angle_FFO: -6.89833140210849,
            pronation_angle_foot_out: 0.13792731202491507,
            propulsion_speed: 1.9656285051422193,
            stride_length: 1.3614832045821519,
            loading_time: 0.11538461546261125,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.24038461554710544,
            walking_speed: 1.4302449816245615,
            foot_progression_angle_FF: 6.7172763434665,
            clearance: 0.006043986011959407,
            circumduction: 0.021734442362638648,
            plantar_flexion_angle_foot_in: -26.457868553167394,
            plantar_flexion_angle_foot_out: 48.276633577647765,
            step_by_step_angle: 0.5292628451868878,
            cumulative_distance: 16.898341613859,
            time_foot_in: 14.4230769,
          },
          {
            swing_speed: 1.930917528757347,
            step_by_step_cadence: 61.782178176059425,
            stance_time: 0.5865384619349392,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.37500000025348434,
            pronation_angle_foot_in: -12.497477119865735,
            pronation_angle_FFI: -5.885667046147172,
            pronation_angle_FFO: -6.550917951666241,
            pronation_angle_foot_out: 4.814841918095057,
            propulsion_speed: 1.6944067467880657,
            stride_length: 1.359874183776654,
            loading_time: 0.1250000000844942,
            propulsion_time: 0.2307692309252225,
            flatfoot_time: 0.2307692309252225,
            walking_speed: 1.4002664853185431,
            foot_progression_angle_FF: 9.481965137423453,
            clearance: 0.005795683122307792,
            circumduction: 0.006487772955924225,
            plantar_flexion_angle_foot_in: -28.92183987994805,
            plantar_flexion_angle_foot_out: 49.88760095300931,
            step_by_step_angle: 0.11993398490345857,
            cumulative_distance: 18.263780026818452,
            time_foot_in: 15.3846154,
          },
          {
            swing_speed: 2.137064998855144,
            step_by_step_cadence: 63.673469344714306,
            stance_time: 0.5576923080692868,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.4762766498387485,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.9810709314253225,
            swing_time: 0.36538461563159963,
            pronation_angle_foot_in: -12.612219649882487,
            pronation_angle_FFI: -5.092062574803576,
            pronation_angle_FFO: -6.992480752399402,
            pronation_angle_foot_out: -2.36168680734811,
            propulsion_speed: 2.1683581133232845,
            stride_length: 1.4330927934679316,
            loading_time: 0.12500000008449597,
            propulsion_time: 0.21153846168145307,
            flatfoot_time: 0.2211538463033378,
            walking_speed: 1.520833167550189,
            foot_progression_angle_FF: 9.642202890388862,
            clearance: 0.009360970691530662,
            circumduction: -0.010349374961525423,
            plantar_flexion_angle_foot_in: -31.44597393089459,
            plantar_flexion_angle_foot_out: 51.2629641516013,
            step_by_step_angle: 6.990751112086043,
            cumulative_distance: 19.705308900004237,
            time_foot_in: 16.3076923,
          },
          {
            swing_speed: 2.0061899963345518,
            step_by_step_cadence: 64.32989686373197,
            stance_time: 0.5769230773130545,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3653846156316014,
            pronation_angle_foot_in: -12.914393861268277,
            pronation_angle_FFI: -5.800893800981495,
            pronation_angle_FFO: -6.048786827303099,
            pronation_angle_foot_out: 1.6691551120466093,
            propulsion_speed: 1.9067153928137557,
            stride_length: 1.3944783963764102,
            loading_time: 0.1346153847063789,
            propulsion_time: 0.23076923092521895,
            flatfoot_time: 0.21153846168145662,
            walking_speed: 1.495110856959947,
            foot_progression_angle_FF: 9.373153976325582,
            clearance: 0.005010296293925687,
            circumduction: 0.011995236691170611,
            plantar_flexion_angle_foot_in: -30.336781348254366,
            plantar_flexion_angle_foot_out: 53.49166828743415,
            step_by_step_angle: 4.545791473663591,
            cumulative_distance: 21.10763123384765,
            time_foot_in: 17.25,
          },
          {
            swing_speed: 1.951384715370956,
            step_by_step_cadence: 61.782178176059425,
            stance_time: 0.6153846158005933,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.7101055991290353,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.839530357942127,
            swing_time: 0.394230769497252,
            pronation_angle_foot_in: -11.443667609991941,
            pronation_angle_FFI: -5.799406667026019,
            pronation_angle_FFO: -7.783677330867188,
            pronation_angle_foot_out: 3.498203184417312,
            propulsion_speed: 2.085979094888705,
            stride_length: 1.3715251975932183,
            loading_time: 0.12500000008449774,
            propulsion_time: 0.24038461554710722,
            flatfoot_time: 0.2500000001689884,
            walking_speed: 1.412263568844322,
            foot_progression_angle_FF: 9.651827040827085,
            clearance: 0.02335957725696021,
            circumduction: 0.004986648916540788,
            plantar_flexion_angle_foot_in: -27.388893377772735,
            plantar_flexion_angle_foot_out: 58.80640513670411,
            step_by_step_angle: 2.4492588814460836,
            cumulative_distance: 22.4870467668377,
            time_foot_in: 18.2596154,
          },
          {
            swing_speed: 2.1162102229932573,
            step_by_step_cadence: 59.99999995944233,
            stance_time: 0.6057692311787086,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.4038461541191367,
            pronation_angle_foot_in: -9.416489460688114,
            pronation_angle_FFI: -6.368484137870396,
            pronation_angle_FFO: -7.007200683053817,
            pronation_angle_foot_out: 3.3039431028060076,
            propulsion_speed: 1.835902757262609,
            stride_length: 1.4692039335054226,
            loading_time: 0.11538461546261303,
            propulsion_time: 0.21153846168145307,
            flatfoot_time: 0.2788461540346425,
            walking_speed: 1.4692039325122976,
            foot_progression_angle_FF: -0.7066643411231498,
            clearance: 0.01455454285081887,
            circumduction: 0.01792399590009931,
            plantar_flexion_angle_foot_in: -28.95896093924449,
            plantar_flexion_angle_foot_out: 54.25036158701201,
            step_by_step_angle: 6.11060383667535,
            cumulative_distance: 23.961643424554886,
            time_foot_in: 19.2692308,
          },
          {
            swing_speed: 1.4719277746790334,
            step_by_step_cadence: 58.31775696992525,
            stance_time: 0.6153846158005933,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.346153846387832,
            pronation_angle_foot_in: null,
            pronation_angle_FFI: null,
            pronation_angle_FFO: -6.305551521842975,
            pronation_angle_foot_out: -0.05002004565288603,
            propulsion_speed: 1.9845859252268159,
            stride_length: 1.0727959092199804,
            loading_time: 0.10576923084072831,
            propulsion_time: 0.21153846168145307,
            flatfoot_time: 0.29807692327841195,
            walking_speed: 1.0427175185370134,
            foot_progression_angle_FF: null,
            clearance: 0.017394003278649563,
            circumduction: 0.03467483627219747,
            plantar_flexion_angle_foot_in: null,
            plantar_flexion_angle_foot_out: 52.61573574257624,
            step_by_step_angle: 14.921882034851961,
            cumulative_distance: 25.040352771107678,
            time_foot_in: 20.2307692,
          },
          {
            swing_speed: 1.7295637674552895,
            step_by_step_cadence: 56.216216178216236,
            stance_time: null,
            gaitline_FFO: 2.2529931823243716,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: null,
            pronation_angle_foot_in: -11.410004135545952,
            pronation_angle_FFI: -7.520940539229701,
            pronation_angle_FFO: -8.730605798357178,
            pronation_angle_foot_out: null,
            propulsion_speed: 1.4484697957330914,
            stride_length: 1.3817043046977169,
            loading_time: null,
            propulsion_time: 0.25000000016899193,
            flatfoot_time: 0.2788461540346425,
            walking_speed: 1.29456979812098,
            foot_progression_angle_FF: null,
            clearance: 0.007190311528073395,
            circumduction: null,
            plantar_flexion_angle_foot_in: -27.254415975594867,
            plantar_flexion_angle_foot_out: 50.75687094219455,
            step_by_step_angle: 158.8495108142991,
            cumulative_distance: 26.43105739094272,
            time_foot_in: 21.4230769,
          },
          {
            swing_speed: 2.0645049837247242,
            step_by_step_cadence: 56.216216178216236,
            stance_time: 0.5961538465568204,
            gaitline_FFO: null,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.39423076949725555,
            pronation_angle_foot_in: -13.71456336900141,
            pronation_angle_FFI: -5.430873231209544,
            pronation_angle_FFO: -7.020711715440155,
            pronation_angle_foot_out: 6.470838944115339,
            propulsion_speed: 1.848928794592988,
            stride_length: 1.377159610160561,
            loading_time: 0.1346153847063789,
            propulsion_time: 0.20192307705956836,
            flatfoot_time: 0.2596153847908731,
            walking_speed: 1.2903117059449016,
            foot_progression_angle_FF: 9.993284792827737,
            clearance: 0.025829257988339543,
            circumduction: 0.026068282690873596,
            plantar_flexion_angle_foot_in: -27.596997226306236,
            plantar_flexion_angle_foot_out: 48.183732489744465,
            step_by_step_angle: 18.833866456151284,
            cumulative_distance: 27.811510524973368,
            time_foot_in: 22.4134615,
          },
          {
            swing_speed: 2.1389792731530295,
            step_by_step_cadence: 61.782178176059425,
            stance_time: 0.5673076926911698,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.38461538487537084,
            pronation_angle_foot_in: -11.692610930467882,
            pronation_angle_FFI: -6.069396422801129,
            pronation_angle_FFO: -7.086781165076005,
            pronation_angle_foot_out: -5.480681020056513,
            propulsion_speed: 2.111447794217004,
            stride_length: 1.505665340083393,
            loading_time: 0.11538461546260947,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.2307692309252225,
            walking_speed: 1.550388071909155,
            foot_progression_angle_FF: 4.877688955797979,
            clearance: 0.016185159493815018,
            circumduction: 0.029515427552617886,
            plantar_flexion_angle_foot_in: -31.024705875378615,
            plantar_flexion_angle_foot_out: 54.26931245950126,
            step_by_step_angle: 5.890351333763536,
            cumulative_distance: 29.32653632496188,
            time_foot_in: 23.3653846,
          },
          {
            swing_speed: 2.248464788028553,
            step_by_step_cadence: 62.39999995782002,
            stance_time: 0.5769230773130545,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3846153848753673,
            pronation_angle_foot_in: -12.390698187674785,
            pronation_angle_FFI: -7.290836065682003,
            pronation_angle_FFO: -6.927819944192271,
            pronation_angle_foot_out: -0.21915255416897375,
            propulsion_speed: 2.082537060318424,
            stride_length: 1.5748988899948806,
            loading_time: 0.1250000000844942,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.2307692309252225,
            walking_speed: 1.6378948444875223,
            foot_progression_angle_FF: 2.575910245031179,
            clearance: 0.008930303114066444,
            circumduction: 0.04397188773329924,
            plantar_flexion_angle_foot_in: -27.356598615860324,
            plantar_flexion_angle_foot_out: 53.475807955235446,
            step_by_step_angle: 4.155366650870954,
            cumulative_distance: 30.91477557963113,
            time_foot_in: 24.3269231,
          },
          {
            swing_speed: 2.034507161055303,
            step_by_step_cadence: 61.17647054688237,
            stance_time: 0.6057692311787086,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.38461538487537084,
            pronation_angle_foot_in: -11.811126777238085,
            pronation_angle_FFI: -5.359480710082726,
            pronation_angle_FFO: -7.350772151919223,
            pronation_angle_foot_out: 1.906591245899663,
            propulsion_speed: 1.9569676849948385,
            stride_length: 1.4445032215633091,
            loading_time: 0.11538461546261303,
            propulsion_time: 0.2307692309252225,
            flatfoot_time: 0.2596153847908731,
            walking_speed: 1.472826813147408,
            foot_progression_angle_FF: 5.391362668585381,
            clearance: 0.0049453142704687925,
            circumduction: 0.027431635871147008,
            plantar_flexion_angle_foot_in: -24.495209724079952,
            plantar_flexion_angle_foot_out: 53.35786468874993,
            step_by_step_angle: 7.7448580104405575,
            cumulative_distance: 32.37213641297303,
            time_foot_in: 25.3173077,
          },
          {
            swing_speed: 1.8932840897943164,
            step_by_step_cadence: 59.428571388400016,
            stance_time: 0.6442307696662439,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.37500000025348257,
            pronation_angle_foot_in: -12.901147090164743,
            pronation_angle_FFI: -6.055485979324074,
            pronation_angle_FFO: -7.286576546545723,
            pronation_angle_foot_out: 4.236701519650967,
            propulsion_speed: 1.8726440856910318,
            stride_length: 1.2733968219558562,
            loading_time: 0.11538461546260947,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.30769230790029667,
            walking_speed: 1.261269232322755,
            foot_progression_angle_FF: 11.859541535383222,
            clearance: 0.007354708905079152,
            circumduction: -0.005388156764582483,
            plantar_flexion_angle_foot_in: -28.001775739513818,
            plantar_flexion_angle_foot_out: 53.761668400086016,
            step_by_step_angle: 3.603488844211498,
            cumulative_distance: 33.649413037108246,
            time_foot_in: 26.3365385,
          },
          {
            swing_speed: 2.273055718548304,
            step_by_step_cadence: 61.17647054688237,
            stance_time: 0.5769230773130545,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3653846156316014,
            pronation_angle_foot_in: -13.775774174436197,
            pronation_angle_FFI: -6.00596005806646,
            pronation_angle_FFO: -6.21417516424804,
            pronation_angle_foot_out: 5.500759129932574,
            propulsion_speed: 2.069116458759707,
            stride_length: 1.542223026617954,
            loading_time: 0.12500000008449774,
            propulsion_time: 0.22115384630333423,
            flatfoot_time: 0.2307692309252225,
            walking_speed: 1.5724626927436174,
            foot_progression_angle_FF: 7.000678089085955,
            clearance: 0.00374756732553546,
            circumduction: 0.021689097788623105,
            plantar_flexion_angle_foot_in: -31.298524693164595,
            plantar_flexion_angle_foot_out: 54.07674777230091,
            step_by_step_angle: 0.7669565604608047,
            cumulative_distance: 35.19905696092181,
            time_foot_in: 27.2788462,
          },
          {
            swing_speed: 2.046889744463111,
            step_by_step_cadence: 63.03030298769699,
            stance_time: 0.5865384619349392,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.38461538487537084,
            pronation_angle_foot_in: -12.659182326065304,
            pronation_angle_FFI: -6.7549582364797764,
            pronation_angle_FFO: -6.77835782342157,
            pronation_angle_foot_out: 1.9252930214652153,
            propulsion_speed: 2.079646894883913,
            stride_length: 1.3684427959619399,
            loading_time: 0.11538461546261303,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.2500000001689884,
            walking_speed: 1.437556067513538,
            foot_progression_angle_FF: 2.002022709588124,
            clearance: 0.005213861989868854,
            circumduction: 0.03582851176799122,
            plantar_flexion_angle_foot_in: -29.537421096481687,
            plantar_flexion_angle_foot_out: 55.59029069274871,
            step_by_step_angle: 0.33713970396976195,
            cumulative_distance: 36.57440533733291,
            time_foot_in: 28.25,
          },
          {
            swing_speed: 2.081308749811889,
            step_by_step_cadence: 61.17647054688237,
            stance_time: 0.6057692311787086,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.37500000025348257,
            pronation_angle_foot_in: -11.522279280602032,
            pronation_angle_FFI: -5.85423862686449,
            pronation_angle_FFO: -6.250975733642505,
            pronation_angle_foot_out: 4.9924264466121535,
            propulsion_speed: 2.1361316015699856,
            stride_length: 1.396639231272708,
            loading_time: 0.11538461546260947,
            propulsion_time: 0.2307692309252225,
            flatfoot_time: 0.25961538479087665,
            walking_speed: 1.4240243132762542,
            foot_progression_angle_FF: 7.621754106306607,
            clearance: 0.0013472200101027343,
            circumduction: 0.01448404305629554,
            plantar_flexion_angle_foot_in: -29.791740264323852,
            plantar_flexion_angle_foot_out: 55.24691470632468,
            step_by_step_angle: 6.825331966362777,
            cumulative_distance: 37.974627954355306,
            time_foot_in: 29.2307692,
          },
          {
            swing_speed: 2.1404648733121654,
            step_by_step_cadence: 63.03030298769699,
            stance_time: 0.5769230773130545,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.40384615411914027,
            pronation_angle_foot_in: -11.784243712947253,
            pronation_angle_FFI: -6.168728126199412,
            pronation_angle_FFO: -5.974694709705846,
            pronation_angle_foot_out: 5.554493152802201,
            propulsion_speed: 2.0342065597148444,
            stride_length: 1.5765007184244553,
            loading_time: 0.11538461546261303,
            propulsion_time: 0.23076923092521895,
            flatfoot_time: 0.2307692309252225,
            walking_speed: 1.6561219657102564,
            foot_progression_angle_FF: 6.244997846223839,
            clearance: 0.018504323873502905,
            circumduction: 0.03156341529951272,
            plantar_flexion_angle_foot_in: -30.027440606863095,
            plantar_flexion_angle_foot_out: 54.850508763913275,
            step_by_step_angle: 4.705527353083826,
            cumulative_distance: 39.56516942196172,
            time_foot_in: 30.2115385,
          },
          {
            swing_speed: 2.1366089138261746,
            step_by_step_cadence: 59.99999995944233,
            stance_time: 0.5961538465568239,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.394230769497252,
            pronation_angle_foot_in: -12.798743042977453,
            pronation_angle_FFI: -5.390116864845274,
            pronation_angle_FFO: -5.442433767371674,
            pronation_angle_foot_out: 4.581933037650777,
            propulsion_speed: 1.9541842988350615,
            stride_length: 1.556364600250788,
            loading_time: 0.1346153847063789,
            propulsion_time: 0.2307692309252225,
            flatfoot_time: 0.2307692309252225,
            walking_speed: 1.5563645991987458,
            foot_progression_angle_FF: 8.163092643529524,
            clearance: 0.005991657411214081,
            circumduction: 0.008484326546160747,
            plantar_flexion_angle_foot_in: -29.480056982064948,
            plantar_flexion_angle_foot_out: 56.269916303636116,
            step_by_step_angle: 1.3920140493546707,
            cumulative_distance: 41.133973789585234,
            time_foot_in: 31.2019231,
          },
          {
            swing_speed: null,
            step_by_step_cadence: 58.31775696992525,
            stance_time: 0.6442307696662439,
            gaitline_FFO: null,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3557692310097167,
            pronation_angle_foot_in: null,
            pronation_angle_FFI: null,
            pronation_angle_FFO: -6.9528636723134385,
            pronation_angle_foot_out: -0.9503444691406736,
            propulsion_speed: 1.4881320421880007,
            stride_length: null,
            loading_time: 0.1250000000844942,
            propulsion_time: 0.24038461554710366,
            flatfoot_time: 0.2788461540346461,
            walking_speed: 0.8941797327594647,
            foot_progression_angle_FF: null,
            clearance: 0.0036216946141327255,
            circumduction: 0.06387294239219163,
            plantar_flexion_angle_foot_in: null,
            plantar_flexion_angle_foot_out: 50.710299897387635,
            step_by_step_angle: 5.836241527629101,
            cumulative_distance: 42.057789426778314,
            time_foot_in: 32.2019231,
          },
          {
            swing_speed: 1.7445037428277104,
            step_by_step_cadence: 54.73684206826317,
            stance_time: 0.7019230773975522,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.42307692336290614,
            pronation_angle_foot_in: -12.527504665887573,
            pronation_angle_FFI: -7.479246569290892,
            pronation_angle_FFO: -7.796295487279586,
            pronation_angle_foot_out: null,
            propulsion_speed: null,
            stride_length: 1.2644285345859174,
            loading_time: 0.17307692319391776,
            propulsion_time: 0.20192307705956836,
            flatfoot_time: 0.3269230771440661,
            walking_speed: 1.15351375007058,
            foot_progression_angle_FF: null,
            clearance: null,
            circumduction: null,
            plantar_flexion_angle_foot_in: -31.696220057972525,
            plantar_flexion_angle_foot_out: null,
            step_by_step_angle: 158.7352420857081,
            cumulative_distance: 43.32402376971597,
            time_foot_in: 33.3269231,
          },
          {
            swing_speed: 1.7917982213224932,
            step_by_step_cadence: 59.428571388400016,
            stance_time: 0.6250000004224745,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.4038461541191367,
            pronation_angle_foot_in: -12.18803816775727,
            pronation_angle_FFI: -8.993681383089912,
            pronation_angle_FFO: -7.334047345453311,
            pronation_angle_foot_out: 2.8350916970318094,
            propulsion_speed: 1.9983530305758006,
            stride_length: 1.3337975047781327,
            loading_time: 0.1346153847063789,
            propulsion_time: 0.23076923092521895,
            flatfoot_time: 0.25961538479087665,
            walking_speed: 1.3210946705062845,
            foot_progression_angle_FF: 7.580932853472658,
            clearance: 0.019518056418186172,
            circumduction: 0.029530271099570415,
            plantar_flexion_angle_foot_in: -28.08795275944519,
            plantar_flexion_angle_foot_out: 53.76134427923594,
            step_by_step_angle: 19.467839559668725,
            cumulative_distance: 44.66123912500502,
            time_foot_in: 34.3557692,
          },
          {
            swing_speed: 1.9876298571369844,
            step_by_step_cadence: 59.428571388400016,
            stance_time: 0.6153846158005933,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3846153848753673,
            pronation_angle_foot_in: -11.082062013218078,
            pronation_angle_FFI: -5.827991031054092,
            pronation_angle_FFO: -8.766044362989737,
            pronation_angle_foot_out: 2.859638846042776,
            propulsion_speed: 2.3589204512444564,
            stride_length: 1.3832231142744362,
            loading_time: 0.15384615395014833,
            propulsion_time: 0.2500000001689884,
            flatfoot_time: 0.21153846168145662,
            walking_speed: 1.3700495598790556,
            foot_progression_angle_FF: 10.750277075581584,
            clearance: 0.01887001478065177,
            circumduction: -0.0033394651727277932,
            plantar_flexion_angle_foot_in: -28.715963717321436,
            plantar_flexion_angle_foot_out: 61.90728112917135,
            step_by_step_angle: 2.986561075828821,
            cumulative_distance: 46.0473734487631,
            time_foot_in: 35.3557692,
          },
          {
            swing_speed: 2.0323899248401767,
            step_by_step_cadence: 59.99999995944233,
            stance_time: 0.5865384619349427,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.3846153848753673,
            pronation_angle_foot_in: -12.46745211445681,
            pronation_angle_FFI: -6.479573728635268,
            pronation_angle_FFO: -6.302894469927986,
            pronation_angle_foot_out: 4.481831212214987,
            propulsion_speed: 1.975303077012497,
            stride_length: 1.3627684116118317,
            loading_time: 0.12500000008449774,
            propulsion_time: 0.21153846168145662,
            flatfoot_time: 0.2500000001689884,
            walking_speed: 1.3627684106906532,
            foot_progression_angle_FF: 7.631944060632061,
            clearance: 0.011677560921191904,
            circumduction: 0.014326278734353971,
            plantar_flexion_angle_foot_in: -29.612012871529355,
            plantar_flexion_angle_foot_out: 50.4348111892112,
            step_by_step_angle: 7.631307470673688,
            cumulative_distance: 47.41551828647725,
            time_foot_in: 36.3269231,
          },
          {
            swing_speed: 2.0935899161863754,
            step_by_step_cadence: 62.39999995782002,
            stance_time: 0.5865384619349427,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.5499084953177902,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.902419934785011,
            swing_time: 0.3846153848753673,
            pronation_angle_foot_in: -12.244247063525687,
            pronation_angle_FFI: -5.485118194488039,
            pronation_angle_FFO: -6.9074080583983015,
            pronation_angle_foot_out: 0.3418502015157463,
            propulsion_speed: 1.9535749116450312,
            stride_length: 1.4546752521660622,
            loading_time: 0.11538461546260947,
            propulsion_time: 0.2211538463033378,
            flatfoot_time: 0.2500000001689955,
            walking_speed: 1.5128622612300684,
            foot_progression_angle_FF: 10.809159493914297,
            clearance: 0.011707131933433833,
            circumduction: -0.010714056475103317,
            plantar_flexion_angle_foot_in: -30.18521413698021,
            plantar_flexion_angle_foot_out: 50.67814403287805,
            step_by_step_angle: 4.4522586680102885,
            cumulative_distance: 48.880247595306045,
            time_foot_in: 37.2980769,
          },
          {
            swing_speed: 1.889802214753098,
            step_by_step_cadence: 61.17647054688237,
            stance_time: 0.5961538465568239,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 1.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.047830503220683,
            swing_time: 0.39423076949724845,
            pronation_angle_foot_in: -12.746461046580075,
            pronation_angle_FFI: -4.758433937115775,
            pronation_angle_FFO: -6.30014068768905,
            pronation_angle_foot_out: 3.898027773575708,
            propulsion_speed: 1.926954106916668,
            stride_length: 1.2662081473625548,
            loading_time: 0.11538461546260947,
            propulsion_time: 0.21153846168145662,
            flatfoot_time: 0.2692307694127578,
            walking_speed: 1.2910357572224638,
            foot_progression_angle_FF: 12.25025940491079,
            clearance: 0.0049502084881583724,
            circumduction: 0.0102045878875986,
            plantar_flexion_angle_foot_in: -27.294150776625518,
            plantar_flexion_angle_foot_out: 50.36897455330039,
            step_by_step_angle: 2.496093976799177,
            cumulative_distance: 50.151091134327146,
            time_foot_in: 38.2884615,
          },
          {
            swing_speed: 1.5134615542859973,
            step_by_step_cadence: 57.247706383321116,
            stance_time: 0.6730769235319016,
            gaitline_FFO: 2.0,
            gaitline_foot_in: 3.0,
            gaitline_foot_out: 3.0,
            gaitline_FFI: 2.0,
            swing_time: 0.4134615387410179,
            pronation_angle_foot_in: -6.5705180338035225,
            pronation_angle_FFI: -5.176380756743391,
            pronation_angle_FFO: -7.079786474737847,
            pronation_angle_foot_out: -1.3610084157774756,
            propulsion_speed: 1.5483592438255085,
            stride_length: 1.044558053309899,
            loading_time: 0.11538461546261658,
            propulsion_time: 0.2500000001689884,
            flatfoot_time: 0.30769230790029667,
            walking_speed: 0.9966425456036431,
            foot_progression_angle_FF: -2.1797009621884773,
            clearance: 0.01497624294527081,
            circumduction: 0.008815816758215425,
            plantar_flexion_angle_foot_in: -13.608504219727868,
            plantar_flexion_angle_foot_out: 51.38829316992828,
            step_by_step_angle: 10.15696396051341,
            cumulative_distance: 51.34756353970833,
            time_foot_in: 39.375,
          },
        ],
        debug: {
          segmented_activity: 37,
          recognized_step: 37,
          analysed_step: 36,
          saturation_percent: 0.0,
          frequency_used: 103.99999992970004,
          frequency_flag: false,
          g_flag: false,
          acc_coef: 0.244,
          gyr_coef: 0.07,
          noisy_data: false,
          last_timestamp: 45.5288462,
          line_removed: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
          firewall: {
            aggregate_swing_speed: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': true,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_step_by_step_cadence: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_stance_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': true,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_gaitline_FFO: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': true,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': true,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_gaitline_foot_in: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_gaitline_foot_out: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_gaitline_FFI: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_swing_time: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': true,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_pronation_angle_foot_in: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': true,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': true,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_pronation_angle_FFI: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': true,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': true,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_pronation_angle_FFO: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_pronation_angle_foot_out: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': true,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_propulsion_speed: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_stride_length: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': true,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_loading_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': true,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_propulsion_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_flatfoot_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_walking_speed: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_foot_progression_angle_FF: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': true,
              '18': true,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': true,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_clearance: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': true,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_circumduction: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': true,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_plantar_flexion_angle_foot_in: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': true,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': true,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            aggregate_plantar_flexion_angle_foot_out: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_init: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            sole_length_find_peaks: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            max_1_clearance: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            max_2_clearance: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            clearance_1: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            clearance_2: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            clearance_3: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            circumdunction: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            circumdunction_FPA: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': true,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': true,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_events: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_swing_time: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            degraded_stance_time: {
              '0': true,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            analysis: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            analysis_init: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            gyro_cross_up: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            gyro_cross_down: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            index_FFI: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            nan_in_index: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            order_index: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            swing_time: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            nan_last_step: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            nan_in_main_variables: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': false,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
            values_in_main_variables: {
              '0': false,
              '1': false,
              '2': false,
              '3': false,
              '4': false,
              '5': false,
              '6': true,
              '7': false,
              '8': false,
              '9': false,
              '10': false,
              '11': false,
              '12': false,
              '13': false,
              '14': false,
              '15': false,
              '16': false,
              '17': false,
              '18': false,
              '19': false,
              '20': false,
              '21': false,
              '22': false,
              '23': false,
              '24': false,
              '25': false,
              '26': false,
              '27': false,
              '28': false,
              '29': false,
              '30': false,
              '31': false,
              '32': false,
              '33': false,
              '34': false,
              '35': false,
              '36': false,
            },
          },
        },
      },
      recommendations: {
        podosmart: {
          general_parameters: {
            left: null,
            right: null,
            symmetry: 'GENERAL_PARAMETERS_TEXT_0',
          },
          pronation_angle_foot_in: {
            left: 'ANGLE_HS_TEXT_2',
            right: 'ANGLE_HS_TEXT_2',
            symmetry: 'SYM_ANGLE_HS_TEXT_2',
          },
          pronation_angle_FF: {
            left: 'ANGLE_FF_TEXT_2',
            right: 'ANGLE_FF_TEXT_2',
            symmetry: 'SYM_ANGLE_FF_TEXT_3',
          },
          pronation_angle_foot_out: {
            left: 'ANGLE_TO_TEXT_2',
            right: 'ANGLE_TO_TEXT_1',
            symmetry: 'SYM_ANGLE_TO_TEXT_3',
          },
          clearance: {
            left: 'CLEARANCE_TEXT_2',
            right: 'CLEARANCE_TEXT_2',
            symmetry: 'SYM_MIN_TOE_TEXT_3',
          },
          plantar_flexion_angle_foot_in: {
            left: 'ANGLE_ATTACK_TEXT_1',
            right: 'ANGLE_ATTACK_TEXT_1',
            symmetry: 'SYM_ANGLE_ATTACK_TEXT_1',
          },
          circumduction: {
            left: 'CIRCUMDUCTION_TEXT_2',
            right: 'CIRCUMDUCTION_TEXT_2',
            symmetry: 'SYM_CIRCUMDUCTION_TEXT_2',
          },
          foot_progression_angle_FF: {
            left: 'FOOT_PROGRESSION_ANGLE_TEXT_1',
            right: 'FOOT_PROGRESSION_ANGLE_TEXT_3',
            symmetry: 'SYM_FOOT_PROGRESSION_ANGLE_TEXT_3',
          },
          walking_speed: 'WALKING_SPEED_TEXT_2',
          cadence: 'CADENCE_TEXT_2',
          stride_length: {
            left: 'STRIDE_LENGTH_TEXT_2',
            right: 'STRIDE_LENGTH_TEXT_2',
            symmetry: 'SYM_STRIDE_LENGTH_TEXT_1',
          },
          stride_time: {
            left: 'STRIDE_TIME_TEXT_2',
            right: 'STRIDE_TIME_TEXT_2',
          },
          stance_time: {
            left: 'STANCE_TIME_TEXT_2',
            right: 'STANCE_TIME_TEXT_2',
          },
          swing_time: {
            left: 'OSCILLATION_TIME_TEXT_2',
            right: 'OSCILLATION_TIME_TEXT_2',
          },
          loading_time_percent: {
            left: 'LOADING_TIME_TEXT_2',
            right: 'LOADING_TIME_TEXT_2',
            symmetry: 'SYM_LOADING_TIME_TEXT_3',
          },
          flatfoot_time_percent: {
            left: 'FLAT_FOOT_TIME_TEXT_2',
            right: 'FLAT_FOOT_TIME_TEXT_2',
            symmetry: 'SYM_FLAT_FOOT_TIME_TEXT_1',
          },
          propulsion_time_percent: {
            left: 'PROPULSION_TIME_TEXT_2',
            right: 'PROPULSION_TIME_TEXT_2',
            symmetry: 'SYM_PROPULSION_TIME_TEXT_2',
          },
          double_support: 'DOUBLE_SUPPORT_TEXT_2',
          ratio_propulsion: 'OSCILLATION_PHASE_TEXT_1_2',
        },
        soles: [
          {
            id: 'INSERT_A',
            side: 'left',
            value: 'MEDIUM',
          },
          {
            id: 'INSERT_B',
            side: 'left',
            value: 'HIGH',
          },
          {
            id: 'INSERT_C',
            side: 'left',
            kind: 'SUPINATOR',
            value: 'HIGH',
          },
          {
            id: 'INSERT_A',
            side: 'right',
            value: 'MEDIUM',
          },
          {
            id: 'INSERT_B',
            side: 'right',
            value: 'HIGH',
          },
          {
            id: 'INSERT_C',
            side: 'right',
            kind: 'SUPINATOR',
            value: 'HIGH',
          },
        ],
      },
      interpretations: {
        fall_risk: 'FALL_RISK_TEXT_0',
        roll_out: {
          left: 'ROLL_OUT_TEXT_3',
          right: 'ROLL_OUT_TEXT_4',
          symmetry: 'ROLL_OUT_TEXT_9',
        },
        propulsion: {
          left: null,
          right: null,
        },
        deficit_controle_moteur: {
          left: null,
          right: null,
        },
        tendinite_patte_d_oie: {
          left: null,
          right: null,
        },
        bandelette_ilio_tibiale: {
          left: null,
          right: null,
        },
        probleme_d_hallux: {
          left: null,
          right: null,
        },
        douleur_avant_pied: {
          left: null,
          right: null,
        },
        myoaponevrosite: {
          left: null,
          right: null,
        },
        pied_equin: {
          left: null,
          right: null,
        },
      },
      version: {
        semver: '4.0.0',
        git: '__AUTOREPLACED__',
      },
    };*/

    // Create variable shortcut to avoid wrap
    const stc = {
      left: this._acquisition.computed_data.left,
      right: this._acquisition.computed_data.right,
    };

    // We don't know if both side are the same count of steps, we take the higher
    const maxSteps = Math.max(stc.left.steps.length, stc.right.steps.length);

    const getValueWithKeyAndIndex = (index: number, side: Side, key: string) => {
      return get(stc, `${side}.steps[${index}][${key}]`, null);
    };

    const matrix: ExportExcelMatrix = [
      {
        label: 'Step (int)',
        cmp: ({ index, side }) => index + index + (side === 'left' ? 0 : 1),
      },
      {
        label: 'Analysed (True/False)',
      },
      {
        label: 'Side (L/R)',
        cmp: ({ side }) => (side === 'left' ? 'L' : 'R'),
      },
      {
        label: 'Distance (m)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'cumulative_distance'),
      },
      {
        label: 'Time foot in (s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'time_foot_in'),
      },
      {
        label: 'Walking speed (m/s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'walking_speed'),
      },
      {
        label: 'Step by step cadence (steps/min)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'step_by_step_cadence'),
      },
      {
        label: 'Stride length (m)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'stride_length'),
      },
      {
        label: 'Stride time (s)',
        cmp: ({ index, side }) => {
          let stanceTime = getValueWithKeyAndIndex(index, side, 'stance_time');
          let swingTime = getValueWithKeyAndIndex(index, side, 'swing_time');
          if (isNil(stanceTime) || isNil(swingTime) || stanceTime == '-1' || swingTime == '-1') {
            return null;
          } else {
            return stanceTime + swingTime;
          }
        },
      },
      {
        label: 'Contact time (s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'stance_time'),
      },
      {
        label: 'Duration of oscillation (s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'swing_time'),
      },
      {
        label: 'Duration loading (s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'loading_time'),
      },
      {
        label: 'Duration half contact (s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'flatfoot_time'),
      },
      {
        label: 'Propulsion duration (s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'propulsion_time'),
      },
      {
        label: 'Propulsion speed (m/s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'propulsion_speed'),
      },
      {
        label: 'Average speed of the swing (m/s)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'swing_speed'),
      },
      {
        label: 'Heel strike pronation (°)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'pronation_angle_foot_in'),
      },
      {
        label: 'Toe strike pronation/supination angle (°)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'pronation_angle_FFI'),
      },
      {
        label: 'Heel take-off pronation angle (°)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'pronation_angle_FFO'),
      },
      {
        label: 'Toe take-off pronation angle (°)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'pronation_angle_foot_out'),
      },
      {
        label: 'Foot progression angle (°)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'foot_progression_angle_FF'),
      },
      {
        label: 'Lateral deviation at oscillation (m)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'circumduction'),
      },
      {
        label: 'Plantar flexion angle foot in (°)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'plantar_flexion_angle_foot_in'),
      },
      {
        label: 'Plantar flexion angle foot out (°)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'plantar_flexion_angle_foot_out'),
      },
      {
        label: 'Minimum toe height (m)',
        cmp: ({ index, side }) => getValueWithKeyAndIndex(index, side, 'clearance'),
      },
    ];

    const content: any[] = [];
    const contentMean: any[] = [
      ['Left step by step cadence global', 'Right step by step cadence global'],
      [stc.left.cadence_global, stc.right.cadence_global],
    ];

    // Inject headers
    content.push(matrix.map((x) => x.label));

    // Create rows
    range(maxSteps).forEach((index) => {
      Object.values(Side).forEach((side) => {
        content.push(
          matrix.map((row) => {
            // Check if row is defined
            if (!row) return null;
            // Check if row have a compute function
            if (row.cmp) {
              return row.cmp({ index, side });
            } else {
              return null;
            }
          }),
        );
      });
    });

    // Compute "analyzed" column
    for (let row = 1; row < content.length; row++) {
      content[row].splice(1, 1, content[row].slice(3, -1).filter((row: any) => row !== null && row != '-1').length > 0);
    }

    // -------
    // XLSX*/

    // Create workbook
    const workbook = utils.book_new();

    // Create sheets
    const prototypeSheet = utils.aoa_to_sheet(content);
    const prototypeSheetMean = utils.aoa_to_sheet(contentMean);

    // Append sheet into workbook
    utils.book_append_sheet(workbook, prototypeSheet, 'Prototype');
    utils.book_append_sheet(workbook, prototypeSheetMean, 'Mean data');

    // Write file and download it
    writeFile(
      workbook,
      `pds__${this.$moment(this._acquisition.createdAt).format('YYYY_MM_D__HH_mm_ss')}__${this._patient._id}_${
        this._acquisition._id
      }.xlsx`,
      { bookType: 'xlsx' },
    );
  }

  _open({ patient, acquisition }: { patient: TEntity<TPatient>; acquisition: TEntity<TAcquisition> }) {
    this.internalPatient = patient;
    this.internalAcquisition = acquisition;

    this.open();
  }

  created() {
    this.$pdc.bus!.on('export:excel:open', this._open);
  }
  beforeDestroy() {
    this.$pdc.bus!.off('export:excel:open', this._open);
  }
}
